import React, { useState } from 'react'
import { Box, IconButton } from '@mui/material'

import { AcqPayment } from '../../types.ts'
import { Icon } from '../icon.tsx'

import { RefundAcqDialog } from './refund-acq-dialog.tsx'

export const RefundAcqButton = ({ reverseAllow, id, state }: AcqPayment): React.ReactElement => {
  const [showRefund, setShowRefund] = useState(false)

  const handleTogglePopup = (visible: boolean) => () => setShowRefund(visible)
  const isDisabled = !reverseAllow || state !== 'ACCEPTED'

  return (
    <Box
      onClick={(event) => event.stopPropagation()}
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <IconButton color="primary" onClick={handleTogglePopup(true)} disabled={isDisabled}>
        <Icon name="ArrowBack" />
      </IconButton>
      {showRefund && <RefundAcqDialog id={id} onClose={handleTogglePopup(false)} />}
    </Box>
  )
}
